import "./index.scss";
import { GeneralSmallCheckCompound } from "@wise-emotions/react-icons";
import Markdown, { ExtraProps } from "react-markdown";
import React from "react";

type Props = {
  children: string;
};

type ListElementProps = React.ClassAttributes<HTMLLIElement> &
  React.LiHTMLAttributes<HTMLLIElement> &
  ExtraProps;

const li = ({ children, ...rest }: ListElementProps) => (
  <li className="check-list__element" {...rest}>
    <span className="check-list__icon">
      <GeneralSmallCheckCompound />
    </span>
    <p>{children}</p>
  </li>
);

export const MarkdownCheckList: React.FC<Props> = ({ children }) => (
  <div className="check-list">
    <Markdown
      components={{
        li,
      }}
    >
      {children}
    </Markdown>
  </div>
);

MarkdownCheckList.displayName = "MarkdownCheckList";
